module.exports = __webpack_public_path__ + "static/media/stem-labs-logo2.fd8d4cb1.png";